import { ActionTypes } from '../../../constants';

export const setTemplateList = (templateList: Array<Object>) => {
  return {
    type: ActionTypes.SET_TEMPLATE_LIST,
    templateList,
  };
};
